<template>
    <div class="login">
        <el-row style="width: 100%; height: 80px; background: #12c287">
            <el-col :span="5" style="margin-top: 16px">
                <img src="/static/img/logo.png" alt="" />
            </el-col>
        </el-row>
        <el-row style="margin-top: 200px; margin-left: 360px">
            <el-col :span="5">
                <img src="/static/images/切图版本2-1.png" alt="" />
            </el-col>
            <el-col :span="5" style="margin-left: 275px">
                <div
                    class="welcome1"
                    style="width: 600px; height: 600px; background: #fff"
                >
                    <el-form
                        :class="[
                            msgIsShow
                                ? 'register-form-right'
                                : 'register-form-center',
                        ]"
                        :model="valueForm"
                    >
                        <div style="margin-top: 164px">
                            <p
                                style="
                                    text-align: left;
                                    color: #12c287;
                                    font-size: 24px;
                                "
                            >
                                忘记密码
                            </p>
                            <div
                                style="
                                    width: 96px;
                                    height: 2px;
                                    background: #12c287;
                                    margin-top: -12px;
                                "
                            ></div>
                            <div class="tipMsg">
                                <span v-show="isShowTipMsg">{{ tipMsg }}</span>
                            </div>
                        </div>
                        <el-form-item
                            v-if="false"
                            label=""
                            prop="uname"
                            :rules="{
                                required: true,
                                message: '用户名不能为空',
                                trigger: 'blur',
                            }"
                        >
                            <el-input
                                class="login-input"
                                type="input"
                                placeholder="用户名"
                                v-model="valueForm.uname"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>

                        <el-form-item
                            label=""
                            prop="email"
                            :rules="[
                                {
                                    required: true,
                                    message: '请输入邮箱地址',
                                    trigger: 'blur',
                                },
                                {
                                    type: 'email',
                                    message: '请输入正确的邮箱地址',
                                    trigger: ['blur', 'change'],
                                },
                            ]"
                        >
                            <el-input
                                type="input"
                                class="login-input"
                                prefix-icon="el-icon-s-custom"
                                placeholder="请输入邮箱账号"
                                v-model="valueForm.email"
                                autocomplete="off"
                                style="font-size: 18px"
                            ></el-input>
                        </el-form-item>
                        <div style="margin-top: 30px">
                            <el-button
                                class="loginButton"
                                type="primary"
                                @click="sumbitForm"
                                >找回密码</el-button
                            >
                        </div>

                        <div style="margin-top: 10px">
                            <el-row>
                                <el-col style="text-align: left">
                                    <el-button
                                        class="loginNagtiveButton"
                                        type="text"
                                        @click="cancle"
                                        >返回登录</el-button
                                    >
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'forget-password',
    data() {
        let checkUsername = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入用户名'))
            } else {
                callback()
            }
        }
        return {
            tipMsg: '请您输入用户名或密码！',
            // 是否显示提示信息
            isShowTipMsg: false,
            //文字是否展示
            msgIsShow: true,
            screenWidth: document.body.clientWidth,
            message: '找回密码！',
            valueForm: {
                email: '',
                uname: '',
            },
        }
    },
    watch: {
        screenWidth(val) {
            if (!this.windowTimer) {
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                this.screenWidth = val // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
                if (this.screenWidth < 1140) {
                    this.msgIsShow = false
                } else {
                    this.msgIsShow = true
                }
                this.windowTimer = true
                let that = this
                setTimeout(function () {
                    that.windowTimer = false
                }, 400)
            }
        },
    },
    mounted() {
        const that = this
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth
                window.screenHeight = document.body.clientHeight
                that.screenWidth = window.screenWidth
            })()
        }
    },
    methods: {
        sumbitForm() {
            if (!this.valueForm.email) {
                this.isShowTipMsg = true
                this.tipMsg = '请输入邮箱！'
                return
            } else {
                var reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/
                if (!reg.test(this.valueForm.email)) {
                    this.$message.error('邮箱格式不正确，请重新输入！')
                    return false
                } else {
                    axios({
                        url: $webConfig.V3.backendAPI + 'forget',
                        method: 'post',
                        data: JSON.stringify({
                            mail: this.valueForm.email,
                        }),
                    })
                        .then((res) => {
                            console.log(res)
                            if (
                                res.status == 200 &&
                                res.data['message'] == '邮件已发出请查收'
                            ) {
                                this.$message({
                                    message: res.data['message'],
                                    type: 'success',
                                })
                                this.$router.push({ path: '/login' })
                            } else {
                                this.$message({
                                    message: res.data['message'],
                                    type: 'warning',
                                })
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            }
        },
        cancle() {
            this.$router.go(-1)
        },
    },
}
</script>
<style scoped>
.forget-password {
    position: fixed;
    width: 100%;
    height: 100%;
    background-size: cover;
    top: 0px;
    left: 0px;
    overflow: hidden;
}
#content {
    width: 400px;
    height: 200px;
    margin: 100px auto;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    border-radius: 6px;
}

@media screen and (max-height: 730px) {
    .welcome {
        background: url(/static/img/地理调查表背景.png) no-repeat center;
        background-size: 100% 100%;
        width: 1050px;
        height: 450px;
        position: relative;
        top: 20%;
        left: 13rem;
    }
}
@media screen and (min-height: 730px) {
    .welcome {
        background: url(/static/img/地理调查表背景.png) no-repeat center;
        background-size: 100% 100%;
        width: 73%;
        height: 61%;
        position: relative;
        top: 20%;
        left: 13%;
    }
}

.login-input >>> .el-input-group__prepend {
    padding: 0 0.8rem !important;
    font-size: 20px !important;
}

.login-input >>> .el-input__inner {
    height: 60px;
    font-size: 20px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #e8e8e8 !important;
    border-radius: 0;
    color: black;
    padding-left: 45px;
}
.login-input >>> .el-input__inner:hover {
    border: 1px solid #12c287;
}
.login-input >>> .el-input__inner:focus {
    border: 1px solid #12c287;
}
.login-input >>> .el-input__inner::placeholder {
    font-size: 18px;
}

.register-form-right >>> .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

.register-form-center >>> .el-form-item__label:before {
    display: none;
}
.register-form-right >>> .el-form-item__label:before {
    display: none;
}

.getCodeButton {
    display: block;
    font-size: 20px;
    height: 45px;
    background: #26aadd;
    border-radius: 0;
}
.getCodeButton-disabled {
    background: #f5f5f5;
    font-size: 20px;
    height: 45px;
    color: #12c287;
    border-radius: 0;
}
.getCodeButton-disabled:hover {
    background: #f5f5f5;
    font-size: 20px;
    height: 45px;
    color: #dfcccb;
    border-radius: 0;
}
.loginNagtiveButton {
    color: #12c287 !important;
    font-size: 16px !important;
}
.loginNagtiveButton:hover {
    font-weight: 600 !important;
    color: #12c287 !important;
}
</style>



// WEBPACK FOOTER //
// src/V3/Forget.vue